<template>
  <ExpenseChangeMain isOnlyScheduleChange="S" />
  <!-- <h1>經費變更行程</h1> -->
</template>
<script setup lang="ts">
import ExpenseChangeMain from './expenseChange/ExpenseChangeMain.vue'

definePage({
  meta: {
    action: 'manage', //固定為 manage
    subject: 'EXPENSECHANGESCHEDULE', //系統代碼(系統授權設定中的系統代碼)
  },
})
</script>